import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import NotificationModel from "../models/NotificationModel";
import { getNotificationsList, openScheduleSendNotificationModel, openSendNotificationModel } from "../../store/slices/eventSlice";
import ScheduleNotificationModel from "../models/ScheduleNotificationModel ";
import ScheduledNotification from "./ScheduledNotification";
import EditScheduleNotificationModel from "../models/EditScheduleNotificationModel";

const Notifications = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getNotificationsList());
    }, [dispatch])

    const { isNotificationModelOpen, isScheduleNotificationModelOpen, scheduledNotifications, isEditScheduledNotificationModel } = useSelector((state) => state.event);
    return (
        <div className="polls-box">
            <div className="position-relative">
                <div className="border box-shadow">
                    <div className="pb-2">
                        <div className="top-section">
                            <div className="header-section">
                                <span>Notifications</span>
                            </div>
                        </div>
                        <div className="footer-section pb-2">
                            <div className="d-flex justify-content-end gap-2">
                                <button
                                    onClick={() => {
                                        dispatch(openSendNotificationModel())
                                    }}
                                    className='btn btn-lg btn-dark px-2'
                                >
                                    Send a Notification To All Listeners
                                </button>
                                <button
                                    onClick={() => {
                                        dispatch(openScheduleSendNotificationModel())
                                    }}
                                    className='btn btn-lg btn-success px-2'
                                >
                                    Schedule Send
                                </button>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="top-section">
                <div className="header-section">
                    <span>Scheduled Notifications</span>
                </div>
            </div>
            <div className="scrollable-container position-relative" style={{ overflow: "hidden auto",height:"40vh" }}>
                {scheduledNotifications && scheduledNotifications.length > 0 ? (
                    scheduledNotifications.map((notification, index) => (
                        <ScheduledNotification
                            key={'scheduled_Notification_' + (notification.notification_id || index)}
                            notification={notification}
                        />
                    ))
                ) : (
                    <div className="text-center py-4 text-muted">No records found.</div>
                )}
            </div>
            <NotificationModel show={isNotificationModelOpen} />
            <ScheduleNotificationModel show={isScheduleNotificationModelOpen} />
            <EditScheduleNotificationModel show={isEditScheduledNotificationModel} />

        </div>
    );
};

export default Notifications;
